"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/AFFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_5)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_5`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#DB3E00"
				}),
				/* @__PURE__ */ n("path", {
					d: "M17.228 0H30V24H17.228V0Z",
					fill: "#479900"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H6.7579V24H-6V0Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.9649 8.89124C10.6035 8.89124 9.49475 10 9.49475 11.3614V15.0667H14.4351V11.3614C14.4351 9.99299 13.3263 8.89124 11.9649 8.89124Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.9649 5.91577C8.61752 5.91577 5.90173 8.63156 5.90173 11.9789C5.90173 15.3263 8.61752 18.0351 11.9649 18.0351C15.3123 18.0351 18.028 15.3193 18.028 11.9719C18.028 8.62454 15.3123 5.91577 11.9649 5.91577ZM11.9649 16.9824C9.19998 16.9824 6.95437 14.7368 6.95437 11.9719C6.95437 9.207 9.19998 6.96139 11.9649 6.96139C14.7298 6.96139 16.9754 9.207 16.9754 11.9719C16.9754 14.7438 14.7298 16.9824 11.9649 16.9824Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_5`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as AFFlag };
